// extracted by mini-css-extract-plugin
module.exports = {"skinTypeSelect":"_1-jjEc"};